import { Notification, NotificationEventType } from "@/types";

import { axios } from "../axios.instance";

export type GetNotificationsRequest = {
  perPage?: number;
  cursor?: string;
  events?: NotificationEventType[];
};

export type GetNotificationsResponse = {
  data: Notification[];
  meta: {
    hasNextPage: boolean;
    nextCursor?: string;
  };
};

export const getNotifications = async (params: GetNotificationsRequest): Promise<GetNotificationsResponse> => {
  const { data } = await axios.get(`/notifications`, {
    params,
  });

  return data;
};
